import { render } from "./SingleChartLoader.vue?vue&type=template&id=3937dbae"
import script from "./SingleChartLoader.vue?vue&type=script&lang=js"
export * from "./SingleChartLoader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__